export * from './types';
import DataTable from './DataTable';

export default DataTable;
